var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-cpt-support-doc"},[_c('UiChecklist',{attrs:{"options":_vm.documentOptions},on:{"change":_vm.onDocumentOptionChanged}}),_vm._v(" "),_c('UiStringlist',{attrs:{"records":_vm.documentRecords},on:{"change":_vm.changeDocumentRecord,"add":_vm.addDocumentRecord,"remove":_vm.removeDocumentRecord}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }